import { Component, HostListener } from '@angular/core';
import { MainContentComponent } from './layout/main-content/main-content.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [MainContentComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './purple.style.less']
})
export class AppComponent {
  title = 'gms-admin';
}
